// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.MessageWrapper in volt.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.countNonNull
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Message wrapper, used to form communication between client and target device. All messages
 * should be wrapped in this message to be able to be processed be both sides.
 *
 * @property id Message identifier
 * @property request_type Message request type
 * @property payload Message payload
 */
public class MessageWrapper(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val id: Int = 0,
  @field:WireField(
    tag = 2,
    adapter = "vreo.volt.protocol.RequestType#ADAPTER",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "requestType",
    schemaIndex = 1,
  )
  public val request_type: RequestType = RequestType.GET,
  @field:WireField(
    tag = 3,
    adapter = "vreo.volt.protocol.Ping#ADAPTER",
    oneofName = "payload",
    schemaIndex = 2,
  )
  public val ping: Ping? = null,
  @field:WireField(
    tag = 4,
    adapter = "vreo.volt.protocol.VideoConfiguration#ADAPTER",
    jsonName = "videoConfiguration",
    oneofName = "payload",
    schemaIndex = 3,
  )
  public val video_configuration: VideoConfiguration? = null,
  @field:WireField(
    tag = 5,
    adapter = "vreo.volt.protocol.AnprMessage#ADAPTER",
    jsonName = "anprMessage",
    oneofName = "payload",
    schemaIndex = 4,
  )
  public val anpr_message: AnprMessage? = null,
  @field:WireField(
    tag = 6,
    adapter = "vreo.volt.protocol.DeviceConfiguration#ADAPTER",
    jsonName = "deviceConfiguration",
    oneofName = "payload",
    schemaIndex = 5,
  )
  public val device_configuration: DeviceConfiguration? = null,
  @field:WireField(
    tag = 7,
    adapter = "vreo.volt.protocol.VrmConfigurationList#ADAPTER",
    oneofName = "payload",
    schemaIndex = 6,
  )
  public val vrms: VrmConfigurationList? = null,
  @field:WireField(
    tag = 8,
    adapter = "vreo.volt.protocol.WebRtcAnswer#ADAPTER",
    jsonName = "webrtcAnswer",
    oneofName = "payload",
    schemaIndex = 7,
  )
  public val webrtc_answer: WebRtcAnswer? = null,
  @field:WireField(
    tag = 9,
    adapter = "vreo.volt.protocol.WebRtcReset#ADAPTER",
    jsonName = "webrtcReset",
    oneofName = "payload",
    schemaIndex = 8,
  )
  public val webrtc_reset: WebRtcReset? = null,
  @field:WireField(
    tag = 10,
    adapter = "vreo.volt.protocol.RoiList#ADAPTER",
    oneofName = "payload",
    schemaIndex = 9,
  )
  public val rois: RoiList? = null,
  @field:WireField(
    tag = 11,
    adapter = "vreo.volt.protocol.StaticImage#ADAPTER",
    jsonName = "getImage",
    oneofName = "payload",
    schemaIndex = 10,
  )
  public val get_image: StaticImage? = null,
  @field:WireField(
    tag = 12,
    adapter = "vreo.volt.protocol.DeviceSettings#ADAPTER",
    oneofName = "payload",
    schemaIndex = 11,
  )
  public val settings: DeviceSettings? = null,
  @field:WireField(
    tag = 13,
    adapter = "vreo.volt.protocol.SingleShotAutofocus#ADAPTER",
    jsonName = "singleShotAutofocus",
    oneofName = "payload",
    schemaIndex = 12,
  )
  public val single_shot_autofocus: SingleShotAutofocus? = null,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<MessageWrapper, Nothing>(ADAPTER, unknownFields) {
  init {
    require(countNonNull(ping, video_configuration, anpr_message, device_configuration, vrms, webrtc_answer, webrtc_reset, rois, get_image, settings, single_shot_autofocus) <= 1) {
      "At most one of ping, video_configuration, anpr_message, device_configuration, vrms, webrtc_answer, webrtc_reset, rois, get_image, settings, single_shot_autofocus may be non-null"
    }
  }

  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is MessageWrapper) return false
    if (unknownFields != other.unknownFields) return false
    if (id != other.id) return false
    if (request_type != other.request_type) return false
    if (ping != other.ping) return false
    if (video_configuration != other.video_configuration) return false
    if (anpr_message != other.anpr_message) return false
    if (device_configuration != other.device_configuration) return false
    if (vrms != other.vrms) return false
    if (webrtc_answer != other.webrtc_answer) return false
    if (webrtc_reset != other.webrtc_reset) return false
    if (rois != other.rois) return false
    if (get_image != other.get_image) return false
    if (settings != other.settings) return false
    if (single_shot_autofocus != other.single_shot_autofocus) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + id.hashCode()
      result = result * 37 + request_type.hashCode()
      result = result * 37 + (ping?.hashCode() ?: 0)
      result = result * 37 + (video_configuration?.hashCode() ?: 0)
      result = result * 37 + (anpr_message?.hashCode() ?: 0)
      result = result * 37 + (device_configuration?.hashCode() ?: 0)
      result = result * 37 + (vrms?.hashCode() ?: 0)
      result = result * 37 + (webrtc_answer?.hashCode() ?: 0)
      result = result * 37 + (webrtc_reset?.hashCode() ?: 0)
      result = result * 37 + (rois?.hashCode() ?: 0)
      result = result * 37 + (get_image?.hashCode() ?: 0)
      result = result * 37 + (settings?.hashCode() ?: 0)
      result = result * 37 + (single_shot_autofocus?.hashCode() ?: 0)
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """id=$id"""
    result += """request_type=$request_type"""
    if (ping != null) result += """ping=$ping"""
    if (video_configuration != null) result += """video_configuration=$video_configuration"""
    if (anpr_message != null) result += """anpr_message=$anpr_message"""
    if (device_configuration != null) result += """device_configuration=$device_configuration"""
    if (vrms != null) result += """vrms=$vrms"""
    if (webrtc_answer != null) result += """webrtc_answer=$webrtc_answer"""
    if (webrtc_reset != null) result += """webrtc_reset=$webrtc_reset"""
    if (rois != null) result += """rois=$rois"""
    if (get_image != null) result += """get_image=$get_image"""
    if (settings != null) result += """settings=$settings"""
    if (single_shot_autofocus != null) result += """single_shot_autofocus=$single_shot_autofocus"""
    return result.joinToString(prefix = "MessageWrapper{", separator = ", ", postfix = "}")
  }

  public fun copy(
    id: Int = this.id,
    request_type: RequestType = this.request_type,
    ping: Ping? = this.ping,
    video_configuration: VideoConfiguration? = this.video_configuration,
    anpr_message: AnprMessage? = this.anpr_message,
    device_configuration: DeviceConfiguration? = this.device_configuration,
    vrms: VrmConfigurationList? = this.vrms,
    webrtc_answer: WebRtcAnswer? = this.webrtc_answer,
    webrtc_reset: WebRtcReset? = this.webrtc_reset,
    rois: RoiList? = this.rois,
    get_image: StaticImage? = this.get_image,
    settings: DeviceSettings? = this.settings,
    single_shot_autofocus: SingleShotAutofocus? = this.single_shot_autofocus,
    unknownFields: ByteString = this.unknownFields,
  ): MessageWrapper = MessageWrapper(id, request_type, ping, video_configuration, anpr_message, device_configuration, vrms, webrtc_answer, webrtc_reset, rois, get_image, settings, single_shot_autofocus, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<MessageWrapper> = object : ProtoAdapter<MessageWrapper>(
      FieldEncoding.LENGTH_DELIMITED, 
      MessageWrapper::class, 
      "type.googleapis.com/vreo.volt.protocol.MessageWrapper", 
      PROTO_3, 
      null, 
      "volt.proto"
    ) {
      override fun encodedSize(`value`: MessageWrapper): Int {
        var size = value.unknownFields.size
        if (value.id != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.id)
        }
        if (value.request_type != vreo.volt.protocol.RequestType.GET) {
          size += RequestType.ADAPTER.encodedSizeWithTag(2, value.request_type)
        }
        size += Ping.ADAPTER.encodedSizeWithTag(3, value.ping)
        size += VideoConfiguration.ADAPTER.encodedSizeWithTag(4, value.video_configuration)
        size += AnprMessage.ADAPTER.encodedSizeWithTag(5, value.anpr_message)
        size += DeviceConfiguration.ADAPTER.encodedSizeWithTag(6, value.device_configuration)
        size += VrmConfigurationList.ADAPTER.encodedSizeWithTag(7, value.vrms)
        size += WebRtcAnswer.ADAPTER.encodedSizeWithTag(8, value.webrtc_answer)
        size += WebRtcReset.ADAPTER.encodedSizeWithTag(9, value.webrtc_reset)
        size += RoiList.ADAPTER.encodedSizeWithTag(10, value.rois)
        size += StaticImage.ADAPTER.encodedSizeWithTag(11, value.get_image)
        size += DeviceSettings.ADAPTER.encodedSizeWithTag(12, value.settings)
        size += SingleShotAutofocus.ADAPTER.encodedSizeWithTag(13, value.single_shot_autofocus)
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: MessageWrapper) {
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
        if (value.request_type != vreo.volt.protocol.RequestType.GET) {
          RequestType.ADAPTER.encodeWithTag(writer, 2, value.request_type)
        }
        Ping.ADAPTER.encodeWithTag(writer, 3, value.ping)
        VideoConfiguration.ADAPTER.encodeWithTag(writer, 4, value.video_configuration)
        AnprMessage.ADAPTER.encodeWithTag(writer, 5, value.anpr_message)
        DeviceConfiguration.ADAPTER.encodeWithTag(writer, 6, value.device_configuration)
        VrmConfigurationList.ADAPTER.encodeWithTag(writer, 7, value.vrms)
        WebRtcAnswer.ADAPTER.encodeWithTag(writer, 8, value.webrtc_answer)
        WebRtcReset.ADAPTER.encodeWithTag(writer, 9, value.webrtc_reset)
        RoiList.ADAPTER.encodeWithTag(writer, 10, value.rois)
        StaticImage.ADAPTER.encodeWithTag(writer, 11, value.get_image)
        DeviceSettings.ADAPTER.encodeWithTag(writer, 12, value.settings)
        SingleShotAutofocus.ADAPTER.encodeWithTag(writer, 13, value.single_shot_autofocus)
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: MessageWrapper) {
        writer.writeBytes(value.unknownFields)
        SingleShotAutofocus.ADAPTER.encodeWithTag(writer, 13, value.single_shot_autofocus)
        DeviceSettings.ADAPTER.encodeWithTag(writer, 12, value.settings)
        StaticImage.ADAPTER.encodeWithTag(writer, 11, value.get_image)
        RoiList.ADAPTER.encodeWithTag(writer, 10, value.rois)
        WebRtcReset.ADAPTER.encodeWithTag(writer, 9, value.webrtc_reset)
        WebRtcAnswer.ADAPTER.encodeWithTag(writer, 8, value.webrtc_answer)
        VrmConfigurationList.ADAPTER.encodeWithTag(writer, 7, value.vrms)
        DeviceConfiguration.ADAPTER.encodeWithTag(writer, 6, value.device_configuration)
        AnprMessage.ADAPTER.encodeWithTag(writer, 5, value.anpr_message)
        VideoConfiguration.ADAPTER.encodeWithTag(writer, 4, value.video_configuration)
        Ping.ADAPTER.encodeWithTag(writer, 3, value.ping)
        if (value.request_type != vreo.volt.protocol.RequestType.GET) {
          RequestType.ADAPTER.encodeWithTag(writer, 2, value.request_type)
        }
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
      }

      override fun decode(reader: ProtoReader): MessageWrapper {
        var id: Int = 0
        var request_type: RequestType = RequestType.GET
        var ping: Ping? = null
        var video_configuration: VideoConfiguration? = null
        var anpr_message: AnprMessage? = null
        var device_configuration: DeviceConfiguration? = null
        var vrms: VrmConfigurationList? = null
        var webrtc_answer: WebRtcAnswer? = null
        var webrtc_reset: WebRtcReset? = null
        var rois: RoiList? = null
        var get_image: StaticImage? = null
        var settings: DeviceSettings? = null
        var single_shot_autofocus: SingleShotAutofocus? = null
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> id = ProtoAdapter.INT32.decode(reader)
            2 -> try {
              request_type = RequestType.ADAPTER.decode(reader)
            } catch (e: ProtoAdapter.EnumConstantNotFoundException) {
              reader.addUnknownField(tag, FieldEncoding.VARINT, e.value.toLong())
            }
            3 -> ping = Ping.ADAPTER.decode(reader)
            4 -> video_configuration = VideoConfiguration.ADAPTER.decode(reader)
            5 -> anpr_message = AnprMessage.ADAPTER.decode(reader)
            6 -> device_configuration = DeviceConfiguration.ADAPTER.decode(reader)
            7 -> vrms = VrmConfigurationList.ADAPTER.decode(reader)
            8 -> webrtc_answer = WebRtcAnswer.ADAPTER.decode(reader)
            9 -> webrtc_reset = WebRtcReset.ADAPTER.decode(reader)
            10 -> rois = RoiList.ADAPTER.decode(reader)
            11 -> get_image = StaticImage.ADAPTER.decode(reader)
            12 -> settings = DeviceSettings.ADAPTER.decode(reader)
            13 -> single_shot_autofocus = SingleShotAutofocus.ADAPTER.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return MessageWrapper(
          id = id,
          request_type = request_type,
          ping = ping,
          video_configuration = video_configuration,
          anpr_message = anpr_message,
          device_configuration = device_configuration,
          vrms = vrms,
          webrtc_answer = webrtc_answer,
          webrtc_reset = webrtc_reset,
          rois = rois,
          get_image = get_image,
          settings = settings,
          single_shot_autofocus = single_shot_autofocus,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: MessageWrapper): MessageWrapper = value.copy(
        ping = value.ping?.let(Ping.ADAPTER::redact),
        video_configuration = value.video_configuration?.let(VideoConfiguration.ADAPTER::redact),
        anpr_message = value.anpr_message?.let(AnprMessage.ADAPTER::redact),
        device_configuration = value.device_configuration?.let(DeviceConfiguration.ADAPTER::redact),
        vrms = value.vrms?.let(VrmConfigurationList.ADAPTER::redact),
        webrtc_answer = value.webrtc_answer?.let(WebRtcAnswer.ADAPTER::redact),
        webrtc_reset = value.webrtc_reset?.let(WebRtcReset.ADAPTER::redact),
        rois = value.rois?.let(RoiList.ADAPTER::redact),
        get_image = value.get_image?.let(StaticImage.ADAPTER::redact),
        settings = value.settings?.let(DeviceSettings.ADAPTER::redact),
        single_shot_autofocus = value.single_shot_autofocus?.let(SingleShotAutofocus.ADAPTER::redact),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
